import React from 'react';
const contexts = [{
  emoji: '🛴',
  text: 'Uso personal diario'
}, {
  emoji: '🏍️',
  text: 'Talleres y servicios técnicos'
}, {
  emoji: '🚚',
  text: 'Delivery y movilidad urbana'
}, {
  emoji: '🔧',
  text: 'Reparadores independientes'
}, {
  emoji: '🏪',
  text: 'Negocios de reventa y refurbish'
}, {
  emoji: '🏠',
  text: 'Mantenimiento en casa'
}, {
  emoji: '⚡',
  text: 'Conversiones y mejoras eléctricas'
}, {
  emoji: '💼',
  text: 'Emprendimientos de movilidad'
}];
export function UseContexts() {
  return <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-166">
      <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 md:mb-16" data-id="element-167">
        Utilizado en todo tipo de entornos del{' '}
        <span className="text-[#00b8ff]" data-id="element-168">mundo scooter</span>
      </h2>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-169">
        {contexts.map((ctx, i) => <div key={i} className="bg-zinc-900/80 p-3 md:p-6 rounded-xl border border-zinc-800 hover:border-[#00b8ff]/50 transition-colors text-center" data-id="element-170">
            <div className="text-3xl md:text-4xl mb-2 md:mb-3" data-id="element-171">{ctx.emoji}</div>
            <div className="text-sm md:text-base text-zinc-300 font-medium leading-tight" data-id="element-172">
              {ctx.text}
            </div>
          </div>)}
      </div>
    </section>;
}